import './Button.scss';

export default function Button({ text, subtext = null, children = null, onClick, style_, class_ }) {
    const classes = 'black-button ' + (class_ ? class_ : '');
    return (
        <div className={classes} onClick={onClick} style={style_}>
            {text}
            {subtext && <div className="button-subtext">{subtext}</div>}
            {children}
        </div>
    );
}